"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeZoneEnum = void 0;
var TimeZoneEnum;
(function (TimeZoneEnum) {
    TimeZoneEnum["Prague"] = "Europe/Prague";
    TimeZoneEnum["London"] = "Europe/London";
    TimeZoneEnum["NewYork"] = "America/New_York";
    TimeZoneEnum["LosAngeles"] = "America/Los_Angeles";
    TimeZoneEnum["Tokyo"] = "Asia/Tokyo";
    TimeZoneEnum["UTC"] = "UTC";
})(TimeZoneEnum = exports.TimeZoneEnum || (exports.TimeZoneEnum = {}));
//# sourceMappingURL=time-zone.js.map